import * as React from 'react';
export const IcDthSignal = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.05 5.64a1 1 0 00-1.41 0 9 9 0 1012.72 12.72 1 1 0 00.3-.7.998.998 0 00-.3-.71L7.05 5.64zm6.07-2.56a1.007 1.007 0 10-.24 2 7 7 0 016.06 6.06 1 1 0 001 .88h.12a1 1 0 00.87-1.11 9 9 0 00-7.81-7.83zm1.77 8.17a1 1 0 001 .75h.25a1 1 0 00.72-1.22 5 5 0 00-3.58-3.58 1.002 1.002 0 10-.5 1.94 3 3 0 012.11 2.11z'
      fill='currentColor'
    />
  </svg>
);
